import { SubmissionError } from 'redux-form';
import { createPhoneCode, createCustomer } from '../signupActions';
import { validateEmail } from '../../../utils/validator';

const submit = (values, dispatch, props) => {
  let phoneNumber;
  if (values.phoneNumber) {
    phoneNumber = `${values.callingCode}${values.phoneNumber
      .replace(/\s/g, '')
      .replace(/^0/, '')}`;
  }

  if (!values.phoneNumber) {
    throw new SubmissionError({
      phoneNumber: 'Champ requis'
    });
  }

  if (!values.email) {
    throw new SubmissionError({
      email: 'Champ requis'
    });
  }

  if (!values.companyName) {
    throw new SubmissionError({
      companyName: 'Champ requis'
    });
  }

  if (!values.companyRegistrationNumber) {
    throw new SubmissionError({
      companyRegistrationNumber: 'Champ requis'
    });
  }

  if (!values.companyVatNumber) {
    throw new SubmissionError({
      companyVatNumber: 'Champ requis'
    });
  }

  if (values.email && !validateEmail(values.email)) {
    throw new SubmissionError({
      email: 'Adresse email invalide'
    });
  }
  if (props.createPhoneCodeSuccess && !values.confirmationCode) {
    throw new SubmissionError({
      confirmationCode: 'Champ requis'
    });
  }

  if (values.phoneNumber && !values.confirmationCode) {
    dispatch(createPhoneCode({ phoneNumber }));
  }
  if (props.createPhoneCodeSuccess && values.confirmationCode) {
    const {
      email,
      confirmationCode,
      companyName,
      companyRegistrationNumber,
      companyVatNumber
    } = values;
    dispatch(
      createCustomer({
        phoneNumber,
        email,
        companyName,
        companyRegistrationNumber,
        companyVatNumber,
        confirmationCode,
        customerType: 'professional'
      })
    );
  }
};

export default submit;
